<template>
  <div class="ui">
    <div class="ui-container" style="background-color: #7057e9; padding: 40px">
      <Button type="secondary" left-icon="check" size="small" overlay @click="openChangesModal">{{
        $t('All published')
      }}</Button>
      <!--      <Button type="secondary" size="small" overlay>{{ $t('12 unpublished changes') }}</Button>-->
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui-v2/Button';
  import TenderPositionCard from '@/containers/tender/position/TenderPositionCard';
  import { mapActions } from 'vuex';
  import ProjectChangesModal from '@/containers/project/ProjectChangesModal';

  const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  export default {
    name: 'Components',
    components: {
      Button,
    },
    data() {
      return {
        picker: new Date().toISOString().substr(0, 10),
        picker2: new Date().toISOString().substr(0, 10),
      };
    },
    methods: {
      ...mapActions('modal', ['openModal']),
      getDay(date) {
        let i = new Date(date).getDay(date);
        return daysOfWeek[i];
      },
      openCard() {
        this.openModal({
          component: TenderPositionCard,
          context: {
            attributes: {
              class: ['create-tender__container'],
            },
          },
        });
      },
      openChangesModal() {
        this.openModal({
          component: ProjectChangesModal,
          context: {
            attributes: {
              class: ['create-tender__container'],
            },
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ui {
    margin: 20px;
  }

  .ui-container__row {
    margin-bottom: 20px;
    > * {
      margin-right: 20px;
    }
  }

  .svg-color * {
    fill: white;
  }

  .color-item {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.32);
    box-sizing: border-box;
    border-radius: 20px;

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 16px;

    .color {
      position: static;
      width: 40px;
      height: 40px;
      left: 32px;
      top: 24px;

      background: #04080e;
      border: 1px solid rgba(0, 0, 0, 0.12);
      border-radius: 50%;
      box-sizing: border-box;
    }
  }

  .table {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    .span {
      padding: 8px 4px;
      border-bottom: 1px solid #a0a3a7;
    }
  }
</style>
